import { ArrowRightIcon } from 'lucide-react';
import { PositionChip } from './PositionChip';
import { Button } from '../primitives/Button';

/**
 * The entire commercial argument for the product, on one line: you win on
 * Google but AI barely names you. `#3 → 4/15`, one sentence, a button through
 * to Questions. Missing from the original prototype (§Your score).
 */
export function GapBanner({
  googlePosition,
  namedCount,
  questionsTested,
  onSeeQuestions,
}: {
  googlePosition: number;
  namedCount: number;
  questionsTested: number;
  onSeeQuestions: () => void;
}) {
  return (
    <div className="mb-5 rounded-lg border border-amber-200 bg-amber-50 p-4">
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2">
          <PositionChip position={googlePosition} />
          <ArrowRightIcon className="h-4 w-4 text-gray-400" />
          <span className="rounded-md border border-amber-300 bg-white px-2 py-0.5 text-xs font-semibold text-amber-700 tabular-nums">
            named in {namedCount} of {questionsTested}
          </span>
        </div>
        <p className="min-w-[16rem] flex-1 text-sm text-gray-700">
          People searching Google find you near the top — but when they ask an AI the same question,
          you are barely mentioned. That gap is where your next customers are going instead.
        </p>
        <Button size="sm" onClick={onSeeQuestions}>
          See the questions
          <ArrowRightIcon className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
